import React from "react";
import { SidebarContainers } from "@components";
import { LocationsSideBarProps } from "./types";
import { STRING } from "@constants";
import { LocationForm } from "./LocationForm";

export function LocationsSideBar({
  show,
  onClose,
  editValues,
  onLocationUpdated,
}: LocationsSideBarProps) {
  return (
    <SidebarContainers
      show={show}
      onClose={onClose}
      title={
        editValues
          ? STRING.LOCATION_FORM.TITLE_UPDATE
          : STRING.LOCATION_FORM.TITLE_CREATE
      }
    >
      <LocationForm onClose={onClose} editValues={editValues} onLocationUpdated={onLocationUpdated} />
    </SidebarContainers>
  );
}
